{
  "version": 1,
  "asset_id": "0c5657dc-d4c2-4799-b52e-694e06568479",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0c5657dc-d4c2-4799-b52e-694e06568479/hiatal-normal-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0c5657dc-d4c2-4799-b52e-694e06568479/hiatal-normal-v3-800.webp",
  "original_filename": "hiatal-normal-v3-800.webp",
  "size": 88900,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:12:16Z"
}
